export default class SocializeRequestHandler {

  constructor() {
    /**
     * selectors
     * @type {{comments: string}}
     */
    this.SELECTORS = {
      comments: '.js-comment',
      socializeItem: '.js-socialize-item',
    };

    /**
     * classes
     * @type {{icon: {sharelist_open: string, active: string}}}
     */
    this.CLASSES = {
      icon: {
        active: 'socialize-widget--active',
        sharelist_open: 'share-list--visible',
      },
    };

    /**
     * types of social Items
     * @type {{bookmark: string, like: string, comment: string, share: string}}
     */
    this.TYPES = {
      like: 'like',
      comment: 'comment',
      share: 'share',
      bookmark: 'bookmark',
    };

    /**
     * social items
     * @type {{}}
     */
    this.SOCIAL_ITEMS = {};

    /**
     * request data
     * @type {{arguments: {items: {}}, mvc: {extensionName: string, controller: string, pluginName: string, vendor: string, action: string}}}
     */
    this.REQUEST = {
      tx_linsocialize_index: {
        controller: 'Ajax',
        action: 'meta',
        items: this.SOCIAL_ITEMS,
      }
    };

    /**
     * constant for the EVENT_TRIGGER
     * @type {string}
     */
    this.EVENT_TRIGGER = 'lin-socialize:';
  }

  /**
   * Sets given button icon as active state.
   *
   * @param $likeBtn - Button icon to be active.
   */
  setIconAsActive($likeBtn) {
    $likeBtn.addClass(this.CLASSES.icon.active);
  }

  /**
   * Sets given button icon as default state.
   *
   * @param $likeBtn - Button icon to be default.
   */
  setIconAsDefault($likeBtn) {
    $likeBtn.removeClass(this.CLASSES.icon.active);
  }

  /**
   * Updates like count of given button.
   *
   * @param $likeBtn - Button which like count to be set.
   * @param likeCount - Like count to be set.
   * @param keepZero - To show a "0" as like count or not. Default false.
   */
  setIconValueCount($likeBtn, likeCount, keepZero = false) {
    likeCount = (likeCount === 0 && !keepZero) ? '' : likeCount;
    $likeBtn.find('.value').html(likeCount);
  }

  /**
   * Increases given button like count by 1. Sets 1 if was nothing before.
   *
   * @param $likeBtn - Button to increase like count of.
   */
  increaseIconLikeCount($likeBtn) {
    let currVal = parseInt($likeBtn.find('.value').text()),
        newVal = 1;

    if (!isNaN(currVal)) {
      newVal = currVal + 1;
    }

    this.setIconValueCount($likeBtn, newVal);
  }

  /**
   * Decreases given button like count by 1. Removes value if it hits 0.
   *
   * @param $likeBtn - Button to decrease like count of.
   * @param keepZero - To show a "0" as like count or not. Default false.
   */
  decreaseIconLikeCount($likeBtn, keepZero = false) {
    let currVal = parseInt($likeBtn.find('.value').text()),
        newVal = 0;

    if (!isNaN(currVal)) {
      newVal = currVal - 1;
      newVal = (newVal < 0) ? 0 : newVal;
    }

    this.setIconValueCount($likeBtn, newVal, keepZero);
  }

  /**
   * Returns given button state active or default as boolean.
   *
   * @param $likeBtn - Button to be checked.
   * @return {boolean} - True if button is active, false if button is default.
   */
  getIconActiveState($likeBtn) {
    return ($likeBtn.hasClass(this.CLASSES.icon.active));
  }

  /**
   * Checks if given button is in active state.
   *
   * @param $likeBtn - Button to be checked.
   * @return {boolean} - If button is in active state.
   */
  isIconActive($likeBtn) {
    return (this.getIconActiveState($likeBtn) === true);
  }

  handleIconState($likeBtn) {
    if (this.isIconActive($likeBtn)) {
      this.setIconAsDefault($likeBtn);
      this.decreaseIconLikeCount($likeBtn);
    } else {
      this.setIconAsActive($likeBtn);
      this.increaseIconLikeCount($likeBtn);
    }
  }

  /**
   * Performs toggle-like-action on corresponding news.
   */
  performButtonAction($button) {
    const _this = this;
    let itemObject = $button.attr('data-socialize-object'),
        itemUid = $button.attr('data-socialize-uid');

    _this.handleIconState($button);

    let request = {
      tx_linsocialize_index: {
        controller: 'Ajax',
        action: 'like',
        objectType: itemObject,
        objectUid: itemUid,
      }
    };

    $.ajax({
      url: '/socializerequest',
      type: 'POST',
      dataType: 'json',
      data: request,
      success: function(result) {
        let state = result.state,
            count = result.count;

        if (state === 'active') _this.setIconAsActive($button);
        if (state === 'default') _this.setIconAsDefault($button);

        _this.setIconValueCount($button, count);
      },
    });
  }

  /**
   * update socialize items
   */
  updateSocializeItems() {
    const _this = this;

    // get social items by type
    $('body').find(_this.SELECTORS.socializeItem).each((index, item) => {
      let $item = $(item);
      _this.storeSocialItemsByType($item, _this.getTypeOfSocializeItem($item));
    });
    // request social data
    _this.requestSocializeData().done(response => {
      if (Object.keys(response).length === 0) {
        return;
      }
      // send event for updating comments, likes and bookmarks
      let types = _this.getTypesOfResponse(response);
      Object.keys(types).forEach(type => {
        let responseData = types[type],
            event = new CustomEvent(
            _this.EVENT_TRIGGER + type + ':update', {
              bubbles: true,
              detail: {data: responseData},
            });
        _this.triggerEvent(event);
      });

    });
  }

  /**
   * trigger specific event
   * @param event CustomEvent
   */
  triggerEvent(event) {
    document.querySelector('body').dispatchEvent(event);
  }

  /**
   * get type of the socialize item
   * @param $item
   * @return {*}
   */
  getTypeOfSocializeItem($item) {
    const _this = this;
    let type = $item.attr('data-socialize-type');

    Object.keys(_this.TYPES).forEach(actionType => {
      if (type === actionType) {
        type = _this.TYPES[actionType];
      }
    });
    return type;
  }

  /**
   * store data of the socialize item by given type
   * @param $item
   * @param type
   */
  storeSocialItemsByType($item, type) {
    const _this = this;
    let itemObject;

    switch (type) {
      case _this.TYPES.bookmark:

        let typoLink = $item.attr('data-bookmark-typolink');
        let bookmarkUid = $item.attr('data-bookmark-uid');
        itemObject = 'bookmark';
        if (_this.checkIfDataIsAlreadyStored(
            itemObject,
            null,
            typoLink,
            true)
        ) {
          _this.SOCIAL_ITEMS[itemObject].push(
              {
                'bookmarkUid': bookmarkUid,
                'typolink': typoLink,
                'hasUserInteractedWith': false,
              },
          );
        }
        break;
      case _this.TYPES.share:
        break;
      default: // _this.TYPES.comment , _this.TYPES.like
        itemObject = $item.attr('data-socialize-object'); //news or page
        let uid = $item.attr('data-socialize-uid'); // id of social Item
        if (_this.checkIfDataIsAlreadyStored(itemObject, type, uid, false)) {
          this.SOCIAL_ITEMS[itemObject][type].push(
              {
                'type': itemObject,
                'uid': uid,
                'pid': $item.attr('data-socialize-pid'), // id of socialize-object
                'value': null,
                'hasUserInteractedWith': false,
              },
          );
        }
        break;
    }
  }

  /**
   * check if data of a socialize item is already stored
   * @param itemObject
   * @param itemType
   * @param id
   * @param isTypoLink
   */
  checkIfDataIsAlreadyStored(itemObject, itemType, id, isTypoLink) {
    const _this = this;
    let isInArray = false;

    if (itemType) {
      if (!_this.SOCIAL_ITEMS[itemObject]) {
        _this.SOCIAL_ITEMS[itemObject] = {};
      }
      if (!_this.SOCIAL_ITEMS[itemObject][itemType]) {
        _this.SOCIAL_ITEMS[itemObject][itemType] = [];
      }
    } else {
      if (!this.SOCIAL_ITEMS[itemObject]) {
        this.SOCIAL_ITEMS[itemObject] = [];
      }
    }

    if (itemType && !isTypoLink) {
      // check if itemUid already exist in Array
      _this.SOCIAL_ITEMS[itemObject][itemType].forEach(function(categoryItem) {
        isInArray = (categoryItem.uid === id);
      });
    }

    if (isTypoLink && !itemType) {
      // check if itemTypolink already exist in Array
      _this.SOCIAL_ITEMS[itemObject].forEach(function(item) {
        isInArray = (item.typolink === id);
      });
    }

    return !isInArray;

  }

  /**
   * Requests active state, like & comment count of given item set.
   */
  requestSocializeData() {
    const _this = this;

    if (!_this.SOCIAL_ITEMS) {
      return;
    }

    return $.ajax({
      url: '/socializerequest',
      type: 'POST',
      dataType: 'json',
      data: _this.REQUEST,
      success: function(result) {
          // for type like
          if (result.news) {
            _this.handleLikeButtonAction(result);
            _this.handleCommentButtonAction(result);
          }
        }
    });
  }

  handleLikeButtonAction(result) {
    const _this = this;

    if (result.news.like) {
      let length = result.news.like.length,
          i;
      // set like button states and counts for each element
      for (i = 0; i < length; i++) {
        let uid = result.news.like[i].uid,
            count = result.news.like[i].value,
            state = result.news.like[i].hasUserInteractedWith,
            $button = $('button[data-socialize-uid="'+ uid +'"');

        if (state === true) _this.setIconAsActive($button);
        if (state === false) _this.setIconAsDefault($button);

        _this.setIconValueCount($button, count);
      }
    }
  }

  handleCommentButtonAction(result) {
    const _this = this;

    if (result.news.comment) {
      let length = result.news.comment.length,
          i;
      // set like button states and counts for each element
      for (i = 0; i < length; i++) {
        let uid = result.news.comment[i].uid,
            state = result.news.comment[i].hasUserInteractedWith,
            $button = $('a[data-socialize-uid="'+ uid +'"');

        if (state === true) _this.setIconAsActive($button);
        if (state === false) _this.setIconAsDefault($button);
      }
    }
  }

  /**
   * get object of type of given response
   * @param response
   */
  getTypesOfResponse(response) {
    let keys = Object.keys(response),
        types = {};

    keys.forEach(key => {
      let data = response[key];
      if (Array.isArray(data)) {
        // array holds the actual data
        types[key] = data;
      } else if (typeof data === 'object' && data !== null) {
        // object includes multiple types with data
        for (let [key2, value] of Object.entries(data)) {
          types[key2] = value;
        }
      }
    });

    return types;
  }

}
